<template>
  <a v-on:click="openCloseLeftMenu" id="menuToggle" class="menutoggle pull-left"><i class="fa fa fa-tasks"></i></a>
</template>
<script>
export default {
  name: 'MenuToggle',
  data(){
	  return {
      open:true
    }
  },
  methods:{
    openCloseLeftMenu(e){
        if(this.open){
          document.getElementsByTagName("body")[0].classList.add("open");
          this.open=false;
          console.log("false lett")
        } else {
          document.getElementsByTagName("body")[0].classList.remove("open");
          this.open=true;
          console.log("true lett")
        }
      return e;
    },
  },

};
</script>

<style scoped>
  .logoheight{
    height: 46px;
  }
</style>

